import './App.css';
import './output.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { AskAnalystProvider } from './context/AskAnalystContext';
import AskAnalystGate from './Components/AskAnalyst/AskAnalystGate';
import MMMMPresentation from './Components/MMMPresentation';
import Login from './Components/Auth/Login';
import ForgotPassword from './Components/Auth/ForgotPassword';
import ResetPassword from './Components/Auth/ResetPassword';
import ProtectedRoute from './Components/Auth/ProtectedRoute';
import Sidebar from './Components/Sidebar';
import UserManagement from './Components/UserManagement';
import QuarterlyBudgetPlanner from './Components/QuarterlyBudgetPlanner';
import RetrospectiveOptimalPacing from './Components/RetrospectiveOptimalPacing';
import BudgetCheck from './Components/BudgetCheck';
import { Toaster } from 'react-hot-toast';

function App() {
  return (
    <Router>
      <AuthProvider>
        <AskAnalystProvider>
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 4000,
            success: {
              duration: 4000,
              style: {
                background: '#00ED64',
                color: '#00684A',
                fontWeight: '500',
              },
              iconTheme: {
                primary: '#00684A',
                secondary: '#00ED64',
              },
            },
            error: {
              duration: 5000,
              style: {
                background: '#FFEAE5',
                color: '#970606',
                fontWeight: '500',
              },
              iconTheme: {
                primary: '#970606',
                secondary: '#FFEAE5',
              },
            },
          }}
        />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <div className="flex h-screen overflow-hidden bg-mongodb-gray-light2">
                  <Sidebar />
                  <main className="flex-1 overflow-auto md:ml-64 pt-20 transition-all duration-300">
                    <div className="min-h-full bg-mongodb-gray-light2 px-4">
                      <MMMMPresentation />
                    </div>
                  </main>
                </div>
              </ProtectedRoute>
            }
          />
          <Route
            path="/users"
            element={
              <ProtectedRoute>
                <div className="flex h-screen overflow-hidden bg-mongodb-gray-light2">
                  <Sidebar />
                  <main className="flex-1 overflow-auto md:ml-64 pt-20 bg-mongodb-gray-light2 transition-all duration-300">
                    <UserManagement />
                  </main>
                </div>
              </ProtectedRoute>
            }
          />
          <Route
            path="/budget-planner"
            element={
              <ProtectedRoute>
                <div className="flex h-screen overflow-hidden bg-mongodb-gray-light2">
                  <Sidebar />
                  <main className="flex-1 overflow-auto md:ml-64 pt-20 bg-mongodb-gray-light2 transition-all duration-300">
                    <QuarterlyBudgetPlanner />
                  </main>
                </div>
              </ProtectedRoute>
            }
          />
          <Route
            path="/retrospective-optimal-pacing"
            element={
              <ProtectedRoute>
                <div className="flex h-screen overflow-hidden bg-mongodb-gray-light2">
                  <Sidebar />
                  <main className="flex-1 overflow-auto md:ml-64 pt-20 bg-mongodb-gray-light2 transition-all duration-300">
                    <RetrospectiveOptimalPacing />
                  </main>
                </div>
              </ProtectedRoute>
            }
          />
          {process.env.NODE_ENV === 'development' && (
            <Route path="/budget-check" element={<BudgetCheck />} />
          )}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <AskAnalystGate />
        </AskAnalystProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;